
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipRemoteL as ObiOwnShipRemoteLElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-remote-l.js';
 
 
 

 
 export const ObiOwnShipRemoteL = createComponent({
   react: React,
   tagName: 'obi-own-ship-remote-l',
   elementClass: ObiOwnShipRemoteLElement,
   events: {
     
   }
  });
 
 